import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subject, takeUntil } from 'rxjs';
import { ApplicationLanguages } from 'src/app/enums/lang';
import { partner } from 'src/app/interfaces/category';
import { CategoriesService } from 'src/app/pages/home/service/categories.service';
import { ChangeLangService } from 'src/app/services/change-lang/change-lang.service';

@Component({
  selector: 'app-main-partners',
  templateUrl: './main-partners.component.html',
  styleUrls: ['./main-partners.component.scss'],
})
export class MainPartnersComponent implements OnInit {
  partners: partner[] = [];
  currentPage = 1;
  ApplicationLanguages = ApplicationLanguages;
  currentLang = localStorage.getItem('lang') || ApplicationLanguages.Ar;

  isTablet: boolean = false;
  isMobile: boolean = false;
  private destroyed = new Subject<void>();

  constructor(
    private categoriesService: CategoriesService,
    private changeLangService: ChangeLangService,
    private breakpointObserver: BreakpointObserver
  ) {}

  ngOnInit() {
    this.checkIfMobile();
    this.getOnlinePartnersData();

    this.changeLangService.currentLanguage.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  checkIfMobile() {
    this.breakpointObserver
      .observe([Breakpoints.XSmall])
      .pipe(takeUntil(this.destroyed))
      .subscribe((result) => {
        this.isMobile = result.matches;
      });

    this.breakpointObserver
      .observe([Breakpoints.Small])
      .pipe(takeUntil(this.destroyed))
      .subscribe((result) => {
        this.isTablet = result.matches;
      });
  }

  getOnlinePartnersData() {
    this.categoriesService.getOnlinePartners().subscribe((response: any) => {
      this.partners = response?.filter((partner: partner) => partner?.image);
    });
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
